import { j as f } from "../../utils-BdNIfrGQ.js";
import { createContext as L, useReducer as S, useRef as M, useEffect as b, useContext as V } from "react";
import { D as j } from "../../Div-spVpsZsH.js";
import "../../Div.skeleton-DLnqOZrU.js";
import "../../Flex-BA9xHq_p.js";
import "../../Grid-DJGISvmf.js";
const m = {
  colors: {
    primary: "219 100% 37%",
    // primary bg
    "primary-foreground": "0 0% 100%",
    // primary text
    "primary-hover": "219 100% 30%",
    "primary-light": "215 88% 90%",
    "primary-dark": "223 100% 17%",
    secondary: "0 0% 100%",
    // secondary bg
    "secondary-foreground": "0 0% 10%",
    // secondary text
    tertiary: "0 0% 100%",
    // tertiary bg
    "tertiary-foreground": "0 0% 10%",
    // tertiary text
    light: "240 15% 88%",
    dark: "0 0% 10%"
  }
}, g = (s, t = 30) => {
  const [e, r, a] = s.replace(/,\s?/g, " ").split(" "), n = Number(a.trim().replace("%", ""));
  if (isNaN(n))
    throw new Error("Invalid hsl value provided");
  const o = n + Math.abs(t), c = o >= 100 ? 100 : o;
  return `${e.trim()} ${r.trim()} ${c}%`;
}, h = (s, t = 7) => {
  const [e, r, a] = s.replace(/,\s?/g, " ").split(" "), n = Number(a.trim().replace("%", ""));
  if (isNaN(n))
    throw new Error("Invalid hsl value provided");
  const o = n - Math.abs(t), c = o <= 0 ? 0 : o;
  return `${e.trim()} ${r.trim()} ${c}%`;
}, T = (s) => {
  const { primary: t, secondary: e, tertiary: r, ...a } = s, n = (a["primary-hover"] || h(t)).replace(/,\s?/g, " "), o = (a["primary-light"] || g(t, 10)).replace(/,\s?/g, " "), c = (a["primary-dark"] || h(t, 20)).replace(/,\s?/g, " "), l = (a["secondary-hover"] || h(e)).replace(/,\s?/g, " "), d = (a["secondary-light"] || g(e, 10)).replace(
    /,\s?/g,
    " "
  ), i = (a["secondary-dark"] || h(e, 20)).replace(/,\s?/g, " ");
  return {
    primary: t,
    secondary: e,
    tertiary: r,
    ...a,
    "primary-hover": n,
    "primary-light": o,
    "primary-dark": c,
    "secondary-hover": l,
    "secondary-light": d,
    "secondary-dark": i,
    "tertiary-hover": r ? h(r) : void 0,
    "tertiary-light": r ? g(r, 10) : void 0,
    "tertiary-dark": r ? h(r, 20) : void 0
  };
}, k = (s) => {
  const { brandingColors: t, theme: e = m } = s;
  return t ? { ...e, colors: T(t) } : { ...e, colors: T(e.colors) };
}, x = ({
  theme: s,
  key: t,
  prefix: e = "--",
  base: r = {}
}) => Object.entries(s[t] || {}).reduce((a, [n, o]) => (a[`${e}${n}`] = o, a), r), v = (s) => {
  const t = x({ theme: s, key: "colors" }), e = x({ theme: s, key: "borderRadius", prefix: "--rounded-" });
  return { ...t, ...e };
}, R = (s, t) => {
  let e, r;
  switch (t.type) {
    case "setTheme":
      return e = t.payload || { theme: m }, r = k(e), {
        ...s,
        theme: r,
        cssThemeVariables: v(r),
        themeConfig: e
      };
    case "setBranding":
      return e = {
        ...s.themeConfig,
        brandingColors: t.payload
      }, r = k(e), {
        ...s,
        theme: r,
        cssThemeVariables: v(r),
        themeConfig: e
      };
  }
}, w = (s, t = document.documentElement) => {
  Object.entries(s).forEach(([e, r]) => {
    t.style.setProperty(e, r);
  });
}, B = (s) => {
  const [t, e, r, a] = /^#?([a-f\d]{1,2})([a-f\d]{1,2})([a-f\d]{1,2})$/i.exec(s.trim()) || [];
  if (t) {
    let n = parseInt(e, 16), o = parseInt(r, 16), c = parseInt(a, 16);
    n /= 255, o /= 255, c /= 255;
    const l = Math.max(n, o, c), d = Math.min(n, o, c);
    let i = 0, u, y = (l + d) / 2;
    if (l == d)
      i = u = 0;
    else {
      const p = l - d;
      switch (u = y > 0.5 ? p / (2 - l - d) : p / (l + d), l) {
        case n:
          i = (o - c) / p + (o < c ? 6 : 0);
          break;
        case o:
          i = (c - n) / p + 2;
          break;
        case c:
          i = (n - o) / p + 4;
          break;
      }
      i /= 6;
    }
    return i = Math.round(i * 360), u = Math.round(u * 100), y = Math.round(y * 100), `${i} ${u}% ${y}%`;
  }
  return "";
}, $ = {
  theme: m,
  themeConfig: { theme: m },
  cssThemeVariables: v(m)
}, E = [
  $,
  () => {
  }
], C = L(E), q = ({
  children: s,
  themeConfig: t,
  targetRef: e
}) => {
  const [r, a] = S(R, $), { cssThemeVariables: n } = r, o = M(null);
  return b(() => {
    const c = e?.current ?? o.current ?? void 0;
    w(n, c);
  }, [n, e]), b(() => {
    a({ type: "setTheme", payload: t || { theme: m } });
  }, [t]), /* @__PURE__ */ f.jsx(C.Provider, { value: [r, a], children: /* @__PURE__ */ f.jsx(j, { ref: o, children: s }) });
}, z = () => V(C);
export {
  q as default,
  B as hexToHSL,
  z as useTheme
};
